import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTemplate from '../../../components/template/PageTemplate';
import RecommendProductSaveContainer from '../../../containers/recommend/product/RecommendProductSaveContainer';
import { recommendProductActions } from '../../../store/modules/recommend/product';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import {
  RECOMMEND_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
  RECOMMEND_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL,
  RECOMMEND_PRODUCT_SAVE_MODEL,
} from '../../../store/modules/recommend/product/models';
import { RECOMMEND_PRODUCT_PAGE_NAME } from '../../../constants/service/app/recommendProductConstants';

class RecommendProductCreate extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   *  초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['recommendProductSave'],
      value: RECOMMEND_PRODUCT_SAVE_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { prepareCreateRecommendProduct } = this.props;

    prepareCreateRecommendProduct({
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: RECOMMEND_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  render() {
    return (
      <PageTemplate pageName={RECOMMEND_PRODUCT_PAGE_NAME.RECOMMEND_PRODUCT_CREATE}>
        <RecommendProductSaveContainer />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: recommendProductActions.setData,
  prepareCreateRecommendProduct: recommendProductActions.prepareCreateRecommendProduct,
};

export default connect(null, mapDispatchToProps)(RecommendProductCreate);
